import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import innerBanner from "../assets/images/inner-banner.png";
import DataTable from "react-data-table-component";
import axios from "axios";

const Products = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
  const [filterText, setFilterText] = useState("");

  const tabs = ["All.", "Analyse.", "Aqua.", "Accurate.", "Again."];

  const [analyse, setAnalyse] = useState([]);
  const [aqua, setAqua] = useState([]);
  const [accurate, setAccurate] = useState([]);
  const [again, setAgain] = useState([]);
  const [all, setAll] = useState([]);

  // Fetch all JSON data
  useEffect(() => {
    axios.get("/analyseData.json").then((res) => setAnalyse(res.data.Data || []));
    axios.get("/aquaData.json").then((res) => setAqua(res.data.Data || []));
    axios.get("/accurateData.json").then((res) => setAccurate(res.data.Data || []));
    axios.get("/againData.json").then((res) => setAgain(res.data.Data || []));
    axios.get("/allData.json").then((res) => setAll(res.data.Data || []));
  }, []);

  // ✅ Update tab when navigated from Footer or directly to /products
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    } else {
      setActiveTab(0); // default: All tab
    }
    window.scrollTo(0, 0);
  }, [location.state]);

  // Table columns
  const getColumns = () => [
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div className="p-code">
          <div className="p-code-wrapper">
            <button
              className="text-blue-600 underline"
              onClick={() => navigate(`/products/${row.id}`, { state: { product: row } })}
            >
              {row.code}
            </button>
            <div className="p-code-content">
              <h3>{row.code}</h3>
              <p>
                <strong>Description:</strong> {row.discription}
              </p>
              <p>
                <strong>Unit:</strong> {row.unit}
              </p>
              <p>
                <strong>CAS Nr:</strong> {row.caseNumber}
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.discription,
      sortable: true,
    },
    {
      name: "Unit",
      selector: (row) => row.unit,
      sortable: true,
      width: "130px",
    },
    {
      name: "CAS Nr.",
      selector: (row) => row.caseNumber,
      sortable: true,
      width: "130px",
    },
  ];

  // Filter by code or description
  const filterByCode = (data) => {
    if (!filterText) return data;
    return data.filter((item) =>
      [item.code, item.discription].some((field) =>
        field?.toString().toLowerCase().includes(filterText.toLowerCase())
      )
    );
  };

  return (
    <>
      {/* Banner */}
      <section id="inner-banner-wrapper">
        <div className="banner-image">
          <img className="w-100" src={innerBanner} alt="Products Banner" />
        </div>
        <div className="breadcrumb">
          <h2>Products</h2>
          <ul>
            <li>
              <NavLink to="/">Home &gt; </NavLink>
            </li>
            <li>Products</li>
          </ul>
        </div>
      </section>

      {/* Tabs Section */}
      <section id="products-tabs">
        <div className="container">
          {/* Tabs */}
          <div className="tabs">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`tab ${activeTab === index ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(index);
                  setFilterText("");
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            <div className="search-box p-4">
              <input
                type="text"
                placeholder="Search by Code OR Description"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                className="border rounded"
              />
            </div>

            {/* Render data for active tab */}
            {activeTab === 0 && (
              <DataTable columns={getColumns()} data={filterByCode(all)} pagination highlightOnHover striped />
            )}
            {activeTab === 1 && (
              <DataTable columns={getColumns()} data={filterByCode(analyse)} pagination highlightOnHover striped />
            )}
            {activeTab === 2 && (
              <DataTable columns={getColumns()} data={filterByCode(aqua)} pagination highlightOnHover striped />
            )}
            {activeTab === 3 && (
              <DataTable columns={getColumns()} data={filterByCode(accurate)} pagination highlightOnHover striped />
            )}
            {activeTab === 4 && (
              <DataTable columns={getColumns()} data={filterByCode(again)} pagination highlightOnHover striped />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
